import { render, staticRenderFns } from "./RegistroPersonal.vue?vue&type=template&id=6a5f65ba&scoped=true"
import script from "./RegistroPersonal.vue?vue&type=script&lang=js"
export * from "./RegistroPersonal.vue?vue&type=script&lang=js"
import style0 from "./RegistroPersonal.vue?vue&type=style&index=0&id=6a5f65ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f65ba",
  null
  
)

export default component.exports